export enum REVIEWS_SDK_EVENTS {}

export enum REVIEWS_SDK_METHODS {
    OPEN_REVIEWS_DRAWER = "openReviewsDrawer",
    CLOSE_REVIEWS_DRAWER = "closeReviewsDrawer",
}
